<template>
  <div class="c-popup-slide c-popup-slide--right" :id="id">
    <div class="c-popup-slide__backdrop c-btn-popup-slide-close" :data-popup-id="id"></div>
    <div class="c-popup-slide__container add_package_slide px-0">
      <!-- @start Header-->
      <div class="header_add_packagev2">
        <div class="c-btn-popup-slide-close back_button" :data-popup-id="id">
          <svg width="32" height="32" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000">
            <path d="m15 6-6 6 6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="header_title">Agregar paquete</div>
      </div>

      <!-- @start content-->
      <div class="body_add_packagev2">
        <div class="sections_container">

          <!-- Tipo de envío -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Tipo de envío" />
            <div style="margin: -12px -12px 0 -12px;">
              <CustomRadioButton
                radioId="opcion1"
                :inputValue="typesOfShipments.pointToHome"
                v-model="shipmentType"
                label="Punto Sharf a domicilio"
              />
              <CustomRadioButton
                radioId="opcion2"
                :inputValue="typesOfShipments.pointToPoint"
                v-model="shipmentType"
                label="Punto Sharf a Punto Sharf"
              />
            </div>
          </div>

          <!-- Método de pago -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Método de pago" />
            <div style="margin: -12px -12px 0 -12px;">
              <CustomRadioButton
                radioId="opcion3"
                :inputValue="false"
                v-model="isShippingPaidAtDestination"
                label="Pago en línea"
              />
              <CustomRadioButton
                radioId="opcion4"
                :inputValue="true"
                v-model="isShippingPaidAtDestination"
                label="Pago al recoger el paquete"
                :disabled="shipmentType === typesOfShipments.pointToHome"
                :helperText="shipmentType === typesOfShipments.pointToHome ? 'Disponible en Punto Sharf a Punto Sharf' : 'Este pago corresponde únicamente al servicio de envío'"
              />
            </div>
          </div>

          <!-- Lugar de entrega -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Lugar de entrega" />
            <div v-show='shipmentType === typesOfShipments.pointToHome' class="delivery-place-inputs">
              <SelectAddressButton
                @click='openAddressesModal()'
                :addressData='DestinationAddress'
              />
              <div v-if="tryToAddPackage && !DestinationAddress" style="margin-top: -15px;">
                <ErrorMessage message="Escoge un dirección." />
              </div>
            </div>
            <div v-show='shipmentType === typesOfShipments.pointToPoint' class="delivery-place-inputs">
              <CustomSearchSelect
                v-show='!isShippingPaidAtDestination'
                @itemSelected="setDestinationDistrictData"
                ref="CustomSelectComponentRef"
                v-model="destinationDistrictId"
                :repoSearch="getScharffDistrics"
                label="Distrito"
                placeholder="Busca por departamento, provincia o distrito"
                errorMessage="Ingresa un departamento, provincia o distrito y selecciona uno de los resultados sugeridos."
                :showEmptyInputError="tryToAddPackage && !destinationDistrictId"
              />
              <ErrorMessage v-if="!hasLimaOrCallaoDistrict" style="margin-top: 3px" message="Por el momento solo realizamos envíos de Lima Metropolitana a provincia y de provincia a Lima Metropolitana. Intenta ingresar nuevamente un departamento, provincia o distrito y selecciona uno de los resultados sugeridos."/>

              <!-- Point to point -->
              <CustomSelect
                isForScharffPoints
                v-if="shipmentType === typesOfShipments.pointToPoint"
                label="Punto Sharf"
                placeholder="Selecciona un Punto Sharf"
                :optionList="scharffPointsList"
                v-model="destinationPuntoScharff"
                errorMessage="Selecciona un Punto Sharf."
                :showEmptyInputError="tryToAddPackage && !destinationPuntoScharff"
                @change="setMarketV2"
              />
              <div v-show="shipmentType === typesOfShipments.pointToPoint" class="c-popup-slide__map" id="mp_ps_type1"></div>

              <!-- Point to home -->
              <InputText
                v-if="shipmentType === typesOfShipments.pointToHome"
                label="Dirección"
                :maxLength="150"
                placeholder="Calle/avenida, número, departamento, etc."
                v-model="address"
                missingErrorMessage="Ingresa una dirección."
                :showEmptyInputError="tryToAddPackage && !address"
                :showExtraMessage="true"
                extraMessage="*Todos nuestros recojos y entregas se realizan en el primer piso de la vivienda"
              />
              <InputText
                isOptional
                v-if="shipmentType === typesOfShipments.pointToHome"
                label="Referencia (opcional)"
                :maxLength="150"
                placeholder="Manzana, lote, alrededores"
                v-model="reference"
                missingErrorMessage="Ingresa una referencia."
              />
            </div>
          </div>

          <!-- Datos de quien recibe -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Datos de quien recibe" />
            <div class="delivery-place-inputs">
              <DestinationContactButton
                @click="openContactModal('destination'), trackEvent('click_puntos_envia_paso_3_contacto_btn', `${shipmentType == typesOfShipments.pointToHome ? 'dropoff': 'puntoapunto'}`)"
                :destinationContact="DestinationContact"
                missingErrorMessage="Escoge un contacto. 2"
              />
              <div v-if="tryToAddPackage && !DestinationContact" style="margin-top: -15px;">
                <ErrorMessage
                  message="Escoge un contacto."
                />
              </div>
            </div>
          </div>

          <!-- Código de seguridad -->
          <div v-if='shipmentType === typesOfShipments.pointToPoint' class='title_section-and-section'>
            <FormSectionTitle title='Código de seguridad' />
            <div>
              <label class="custom-input-label">La persona que recibe debe dar el código de seguridad para poderle entregar el paquete</label>
              <div style='display: flex; gap: 10px; align-items: flex-start;' class="pt-1">
                <InputText
                :maxLength='4'
                placeholder='Ej. 4729'
                v-model='securityCode'
                missingErrorMessage='Ingresa un código de seguridad de 4 dígitos.'
                :showEmptyInputError='tryToAddPackage && !securityCode'
              />
              <div style='width: 250px; margin: -4px'>
                <ButtonDefinitive
                variant='secondary'
                size='md'
                label='Generar código'
                @click='generateSecurityCode'
                />
              </div>
            </div>
          </div>
          <div style='margin-top: 6px;'>
              <InformativeMessage
              :message="'Debe tener 4 números. Evita repetir (1111) o poner secuencias (1234). Puedes usar “Generar código”.'"
              />
            </div>
          </div>

          <!-- Características del paquete -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Características del paquete" />
            <div class="delivery-place-inputs">
              <InputText
                label="Descripción del producto"
                :maxLength="150"
                placeholder="¿Qué es lo que envías?"
                v-model="productDescription"
                missingErrorMessage="Ingresa la descripción del producto."
                :showEmptyInputError="tryToAddPackage && !productDescription"
              />
              <CustomCheckbox
                checkboxId="fragile-product"
                v-model="isAFragileProduct"
                label="Producto frágil"
              />
              <div style='padding: 12px 0 16px 0'>
                <InformativeMessage :message="'¡Tus paquetes se miden en 3D! 🔍\nAunque una medida parezca grande, el volumen total podría clasificarse en una talla menor. Te ayudamos a encontrar la mejor opción según sus dimensiones completas 📏×📐×📎'" />
              </div>
              <div class="package_measurements">
                <PackageSizes :sizeList='sizeList' :sizeSelectedId='sizeSelected.tallaId' @onSizeSelected='handleSizeSelected' />
                <div v-if="sizeSelected.codigo === 'P'" class="attributes">
                  <InputPackageAttribute
                    label="Peso"
                    measure="kg"
                    v-model="packageWeight"
                    missingErrorMessage="Ingresa el Peso."
                    :showEmptyInputError="tryToAddPackage && !packageWeight"
                  />
                </div>
                <ErrorMessage v-show="exceedsWeightLimit" :message="`El peso máximo permitido por paquete en el servicio Puntos Sharf es ${maxWeight} kg.`" />
                <div v-if="sizeSelected.codigo === 'P'" style="padding-top: 16px;" class="attributes">
                  <InputPackageAttribute
                    label="Largo"
                    measure="cm"
                    v-model="packageWidth"
                    missingErrorMessage="Ingresa el Largo."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageWidth"
                  />
                  <InputPackageAttribute
                    label="Alto"
                    measure="cm"
                    v-model="packageHeight"
                    missingErrorMessage="Ingresa el Alto."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageHeight"
                  />
                  <InputPackageAttribute
                    label="Ancho"
                    measure="cm"
                    v-model="packageDeep"
                    missingErrorMessage="Ingresa el Ancho."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageDeep"
                  />
                </div>
                <ErrorMessage
                  v-if="
                    packageWidth <= maxLength &&
                    packageHeight <= maxLength &&
                    packageDeep <= maxLength
                  "
                  :message="volumetricWeightMsg"
                  v-show="exceedsVolumetricWeight"
                />
                <div class="attributes" style="padding-top: 16px">
                  <InputPackageAttribute
                    label="Valor del producto"
                    measure="S/"
                    v-model="packageValue"
                    missingErrorMessage="Ingresa el valor del producto."
                    :showEmptyInputError="tryToAddPackage && !packageValue"
                    isCurrency
                  />
                </div>
              </div>
              <div style="padding-top: 8px">
                <InformativeMessage message="Tenemos garantía de hasta S/ 700." />
              </div>
            </div>
          </div>
          <!-- <div v-if="allowSecondAttempt && shipmentType === typesOfShipments.pointToHome">
            <div style="display: flex; flex-direction: column; gap: 4px;">
              <div class="text-l-bold">En caso el destinatario no pueda recibir el paquete</div>
              <div class="text-s-regular" style="color: #737373">Escoge una opción</div>
            </div>
            <div class="secondAttemptOption_container">
              <SecondAttempCards
                :optionSelected="secondAttemptInPS"
                :isLoading="shippingCostIsLoading"
                :aditionalCostCalculated="aditionalCostCalculated"
                @onUpdateOption="updateSecondAttemptOption"
              />
            </div>
            <div class="text-s-regular">El cobro adicional se realizaría solo en caso de que hubiese un 2do intento de entrega en domicilio, luego de haber coordinado contigo.</div>
          </div> -->

          <!-- Información adicional (opcional) -->
          <!-- <div class="title_section-and-section">
            <FormSectionTitle title="Información adicional (opcional)" />
            <InputText
              isTextArea
              placeholder="¿Deseas agregar alguna indicación para tu envío?"
              v-model="adicionalInformation"
            />
          </div> -->

        </div>

        <div class="body_footer">
          <div>
            <ButtonDefinitive
              :isDisabled="shippingCostIsLoading"
              label="Guardar paquete"
              @click="handleAddPackage"
            />
          </div>
          <ShippingCost :isLoading="shippingCostIsLoading" :amount="shippingCost" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import M from "materialize-css";
import InputDistrict from "../General/InputDistrict.vue";
import FavoriteAddress from "../General/FavoriteAddress.vue";
import Map from "../../commons/mixins/maps";
import utils from "../../commons/mixins/utils";
import PackageSizes from "@/components/Shared/PackageSizes.vue";
import SelectAddressButton from "@/components/Button/SelectAddressButton.vue"
import Icon from '@/components/Icon.vue'

import CustomRadioButton from "../Form/CustomRadioButton.vue";
import FormSectionTitle from "../Form/FormSectionTitle.vue";
import CustomSearchSelect from "../Form/CustomSearchSelect.vue";
import { getScharffDistrics, getFare, getSizes } from "../../services/fare"
import InputText from "../Form/InputText.vue";
import DestinationContactButton from "../Button/DestinationContactButton.vue";
import CustomCheckbox from "../Form/CustomCheckbox.vue";
import ErrorMessage from "../ErrorMessage.vue";
import InputPackageAttribute from "../Form/InputPackageAttribute.vue";
import InformativeMessage from "../General/InformativeMessage.vue";
import ButtonDefinitive from "../Button/ButtonDefinitive.vue";
import ShippingCost from "../General/ShippingCost.vue";
import CustomSelect from "../Form/CustomSelect.vue";
import SecondAttempCards from "../Shared/SecondAttempt/SecondAttempCards.vue" 

function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      timeout = null
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export default {
  components: {
    InputDistrict,
    FavoriteAddress,
    PackageSizes,
    SelectAddressButton,
    Icon,

    CustomRadioButton,
    FormSectionTitle,
    CustomSearchSelect,
    InputText,
    DestinationContactButton,
    CustomCheckbox,
    ErrorMessage,
    InputPackageAttribute,
    InformativeMessage,
    ButtonDefinitive,
    ShippingCost,
    SecondAttempCards,
    CustomSelect
  },
  name: "ModalScharffPointPackageV2",
  props: {
    id: String
  },
  data() {
    return {
      typesOfShipments: {
        pointToHome: 'PtH',
        pointToPoint: 'PtP'
      },
      shipmentType: 'PtH',
      destinationDistrictId: '',
      destinationPuntoScharff: '',
      scharffPointsList: [],
      address: '',
      reference: '',
      securityCode: null,
      productDescription: '',
      isAFragileProduct: false,
      maxLength: null,
      maxWeight: null,
      maxVolumetricWeight: null,
      packageWeight: 0,
      packageWidth: 0,
      packageHeight: 0,
      packageDeep: 0,
      packageValue: 0,
      adicionalInformation: '',
      package: {
        hasValueCalculable: false,
        isAddableToList: false
      },
      shippingCostIsLoading: false,
      shippingCost: 0,
      tryToAddPackage: false,
      destinationDistrictData: {},
      selectedScharffPointData: {},
      allowSecondAttempt: false,
      secondAttemptInPS: true,
      aditionalCostCalculated: 0,
      isShippingPaidAtDestination: false,
      sizeList: [],
      sizeSelected: {
        tallaId: null,
        codigo: '',
        descripcion: '',
        alto: null,
        ancho: null,
        profundidad: null,
        pesoMinimo: null,
        pesoMaximo: null,
      },
      map: null,
    };
  },
  methods: {
    getScharffDistrics,
    getSizes,
    setDestinationDistrictData(districtData) {
      if([67, 128].includes(districtData.provinceId)) { // callao y lima
        this.secondAttemptInPS = this.secondAttemptInPS ?? true
        this.allowSecondAttempt = true
      } else {
        this.allowSecondAttempt = false
        this.secondAttemptInPS = null
      }
      this.destinationDistrictData = districtData
    },
    async checkValues() {
      try {
        const {
          DestinationAddress, destinationDistrictId, address, exceedsVolumetricWeight,
          DestinationContact, securityCode, productDescription, packageWeight, maxLength, exceedsWeightLimit,
          packageWidth, packageHeight, packageDeep, packageValue, hasLimaOrCallaoDistrict,
          destinationPuntoScharff, shipmentType, typesOfShipments, reference
        } = this

        const idOfDistrict = shipmentType === typesOfShipments.pointToHome ?
            DestinationAddress?.districtId :
            destinationDistrictId

        const hasValueCalculable = (
          idOfDistrict && hasLimaOrCallaoDistrict &&
          packageWeight && !exceedsWeightLimit &&
          packageWidth && packageWidth <= maxLength &&
          packageHeight && packageHeight <= maxLength &&
          packageDeep && packageDeep <= maxLength && !exceedsVolumetricWeight
        )

        const commonConditions = (
          hasValueCalculable &&
          this.shippingCost > 0 &&
          DestinationContact &&
          productDescription &&
          !this.shippingCostIsLoading &&
          !!packageValue
        )

        if (shipmentType === typesOfShipments.pointToHome) {
          this.package.isAddableToList = !!commonConditions
        }

        // validate if securityCode has 4 digits
        const securityCodeValid = securityCode && /^\d{4}$/.test(securityCode)

        if (shipmentType === typesOfShipments.pointToPoint) {
          this.package.isAddableToList = securityCodeValid && !!commonConditions && !!destinationPuntoScharff
        }

        console.log('hasValueCalculable', hasValueCalculable)
        console.log('this.shippingCost', this.shippingCost)
        console.log('DestinationContact', DestinationContact)
        console.log('securityCode', securityCode)
        console.log('productDescription', productDescription)
        console.log('this.shippingCostIsLoading', this.shippingCostIsLoading)
        console.log('packageValue', packageValue)
        console.log('commonConditions', commonConditions)
        console.log('this.package.isAddableToList', this.package.isAddableToList)
        console.log('_________________')
      } catch (e) {
        console.log("Error in checkValues:", e)
      }
    },
    async checkValuesToCalculate() {
      try {
        const {
          DestinationAddress, destinationDistrictId, packageWeight, packageWidth, packageHeight, packageDeep,
          hasLimaOrCallaoDistrict, exceedsWeightLimit, maxLength, exceedsVolumetricWeight,
          shipmentType, typesOfShipments
        } = this

        const idOfDistrict = shipmentType === typesOfShipments.pointToHome ?
            DestinationAddress?.districtId :
            destinationDistrictId

        const hasValueCalculable = (
          idOfDistrict && hasLimaOrCallaoDistrict &&
          packageWeight && !exceedsWeightLimit &&
          packageWidth && packageWidth <= maxLength &&
          packageHeight && packageHeight <= maxLength &&
          packageDeep && packageDeep <= maxLength && !exceedsVolumetricWeight
        )

        this.package.hasValueCalculable = hasValueCalculable

        if (hasValueCalculable) await this.calculateCost()
        else this.shippingCost = 0
        this.shippingCostIsLoading = false
      } catch (e) {
        console.log("Error in checkValuesToCalculate:", e)
      }
    },
    async calculateCost() {
      this.shippingCostIsLoading = true
      const idOfDestinationDistrict = this.shipmentType === this.typesOfShipments.pointToHome ?
          this.DestinationAddress?.districtId :
          this.destinationDistrictId
      try {
        const fare = await getFare({
          "fareItems": [
            {
              "originDistrictId": this.originDistric.districtId.id,
              "destinationDistrictId": idOfDestinationDistrict,
              "packageWidth": this.packageWidth,
              "packageHeight": this.packageHeight,
              "packageWeight": this.packageWeight,
              "packageDeep": this.packageDeep,
              "serviceType": 4, // puntos
              "sizeId": this.sizeSelected.tallaId,
              "shippingTypeId": this.shipmentType === this.typesOfShipments.pointToHome ? 1 :
                                this.shipmentType === this.typesOfShipments.pointToPoint ? 3 : null
            }
          ]
        })
        this.shippingCost = fare.data.totalFare
        this.aditionalCostCalculated = fare.data.secondTryFare.toFixed(2) || 0
      } catch (e) {
        this.$swal({
          title: "Error!",
          text: e,
          icon: "error",
        })
      } finally {
        this.shippingCostIsLoading = false
      }
    },
    handleAddPackage() {
      this.tryToAddPackage = true
      if(!this.package.isAddableToList) {
        this.$swal({
          text: '¡Ups! 😅 Parece que hay algunos campos que aún no has completado correctamente.',
          icon: "warning",
          confirmButtonText: "Aceptar"
        })
        return
      }

      const allPackageData = {
        index: this.$store.getters.SCHARFFPOINT_INDEX_DESTINATION,
        item: {
          description: this.productDescription,
          destinationAddress: {
            additionalAddress: this.reference,
            contact: this.DestinationContact,
            address: this.DestinationAddress,
            description: this.address,
            districtId: {
              id: this.destinationDistrictData.id,
              text: this.destinationDistrictData.text,
              textToFinded: this.destinationDistrictData.textToFind,
            },
            puntoScharffId: this.selectedScharffPointData
          },
          securityCode: this.securityCode,
          discountFare: null,
          fare: this.shippingCost,
          secondAttemptInPS: this.secondAttemptInPS,
          isPointPoint: this.shipmentType === this.typesOfShipments.pointToPoint,
          packageSize: {
            height: this.packageHeight,
            lengths: this.packageDeep,
            maxWeight: null,
            type: null, // lo que era "pequeño", "mediano", etc
            weight: this.packageWeight,
            width: this.packageWidth
          },
          fragil: this.isAFragileProduct,
          isShippingPaidAtDestination: this.isShippingPaidAtDestination,
          productValue: this.packageValue,
          sizeSelected: this.sizeSelected,
          shippingTypeId: this.shipmentType === this.typesOfShipments.pointToHome ? 1 :
                          this.shipmentType === this.typesOfShipments.pointToPoint ? 3 : null
        },
      }
      this.$store.dispatch("SCHARFFPOINT_ORDER_SET_DESTINATION", allPackageData);
      const popup = document.getElementById(this.id)
      popup.classList.remove("is-active");

      this.trackEvent('click_puntos_envia_guardar_paquete', this.shipmentType == this.typesOfShipments.pointToHome ? 'dropoff': 'puntoapunto')
    },
    updateSecondAttemptOption(option) {
      this.secondAttemptInPS = option
    },
    async getScharffPoints() {
      this.$store
        .dispatch("GET_SCHARFF_POINT", this.destinationDistrictId)
        .then((response) => {
          this.scharffPointsList = response;
          this.scharffPointsList.forEach((item) => {
            this.map?.addMarkerScharffPoint(item.Location, item.Name, item.Name, item);
          })
        })
    },
    setMarketV2(point) {
      const { DepartamentoTexto, ProvinciaTexto, DistritoTexto } = point
      if (this.isShippingPaidAtDestination) {
        this.setDestinationDistrictData({
          departmentId: point.DepartamentoId,
          id: point.DistritoId,
          provinceId: point.ProvinciaId,
          text: utils.methods.toCapitalCase(`${DepartamentoTexto} - ${ProvinciaTexto} - ${DistritoTexto}`),
        })
      }
      this.destinationPuntoScharff = point.ScharffPointId
      this.destinationDistrictId = point.DistritoId
      this.selectedScharffPointData = point
      this.map.centerMap({
        lat: point.Location.Lat,
        lng: point.Location.Lng
      })
    },
    getScharffPointsWithDestinationPayment() {
      this.$store.dispatch('GET_SCHARFF_POINT_WITH_DESTINATION_PAYMENT').then(resp => {
        this.scharffPointsList = resp
        resp.forEach(item => {
          this.map?.addMarkerScharffPoint(item.Location, item.Name, item.Name, item)
        })
      })
    },
    async getSizesForSharfPoints(type) {
      const sizes = await this.getSizes(type)
      const personalizedSize = sizes.find(size => size.codigo === 'P')
      this.maxLength = personalizedSize.alto
      this.maxWeight = personalizedSize.pesoMaximo
      this.maxVolumetricWeight = personalizedSize.pesoMaximo * 5000
      this.sizeList = sizes
    },
    handleSizeSelected(size) {
      this.sizeSelected = size
      if (size.codigo === 'P') {
        this.packageWeight = 0
        this.packageWidth = 0
        this.packageHeight = 0
        this.packageDeep = 0
      } else {
        this.packageWeight = size.pesoMaximo
        this.packageWidth = size.ancho
        this.packageHeight = size.alto
        this.packageDeep = size.profundidad
      }
    },
    async openAddressesModal() {
      this.showLoading();
      await this.$store.dispatch('GET_FAVORITE_LOCATIONS')
      const modalAddressFavorite = document.querySelector('#modal-address-destination')
      const instance = M.Modal.init(modalAddressFavorite, {
        dismissible: false
      })
      instance.open()
      this.$swal.close()
    },
    openContactModal(type) {
      this.showLoading();
      this.$store
        .dispatch("GET_CONTACTS")
        .then((success) => {
          this.$swal.close();
          if (success.status === 200) {
            const contacts = success.data.result.list;
            this.$store.dispatch("GENERAL_SET_CONTACTS", contacts);
            this.$store.dispatch("HELPER_SET_MODAL_CONTACT_TYPE", type);
            const modalContactFavorite = document.querySelector("#modal-contact-destination");
            const instance = M.Modal.init(modalContactFavorite, {
              dismissible: false
            });
            instance.open();
          } else {
            this.showError(success.data.message);
          }
        })
        .catch((error) => {
          const msg = error?.data?.message || "Ocurrio un error.";
          this.showError(msg);
        });
    },
    generateSecurityCode() {
      const isAllSame = (code) => /^(\d)\1{3}$/.test(code)
      const isSequence = (code) => {
        const d1 = code[1] - code[0]
        const d2 = code[2] - code[1]
        const d3 = code[3] - code[2]
        return d1 === d2 && d2 === d3 && Math.abs(d1) === 1
      }
    
      let code = ''
      let tries = 0
    
      while (!code || isAllSame(code) || isSequence(code)) {
        code = Math.floor(1000 + Math.random() * 9000).toString()
        tries++
        if (tries > 30) break // por si acaso
      }
    
      this.securityCode = code
    },
    async clearData() {
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_CONTACT", null);
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_ADDRESS", null)
      this.shipmentType = this.typesOfShipments.pointToHome
      this.destinationDistrictId = ''
      this.scharffPointsList = []
      this.destinationPuntoScharff = ''
      this.address = ''
      this.reference = ''
      this.securityCode = ''
      this.productDescription = ''
      this.isAFragileProduct = false
      this.isShippingPaidAtDestination = false
      this.packageWeight = 0
      this.packageWidth = 0
      this.packageHeight = 0
      this.packageDeep = 0
      this.packageValue = 0
      this.secondAttemptInPS = true
      this.adicionalInformation = ''
      this.package = {
        hasValueCalculable: false,
        isAddableToList: false
      }
      this.shippingCostIsLoading = false
      this.shippingCost = 0
      this.tryToAddPackage = false
      this.destinationDistrictData = {}
      this.selectedScharffPointData = {}
      this.sizeSelected = {
        tallaId: null,
        codigo: '',
        descripcion: '',
        alto: null,
        ancho: null,
        profundidad: null,
        pesoMinimo: null,
        pesoMaximo: null,
      }
    },
    async setData(destination) {
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_CONTACT", destination.destinationAddress.contact);
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_ADDRESS", destination.destinationAddress.address)
      this.shipmentType = destination.isPointPoint ? this.typesOfShipments.pointToPoint : this.typesOfShipments.pointToHome
      this.isShippingPaidAtDestination = destination.isShippingPaidAtDestination
      this.destinationPuntoScharff = destination.destinationAddress.puntoScharffId?.ScharffPointId || ''
      this.selectedScharffPointData = destination.destinationAddress.puntoScharffId
      this.address = destination.destinationAddress.description
      this.reference = destination.destinationAddress.additionalAddress
      this.securityCode = destination.securityCode
      this.productDescription = destination.description
      this.packageWeight = destination.packageSize.weight
      this.packageWidth = destination.packageSize.height
      this.packageHeight = destination.packageSize.lengths
      this.packageDeep = destination.packageSize.width
      this.packageValue = destination.productValue
      this.secondAttemptInPS = destination.secondAttemptInPS
      this.isAFragileProduct = destination.fragil
      this.package = {
        hasValueCalculable: true,
        isAddableToList: true
      }
      this.shippingCostIsLoading = false
      this.shippingCost = destination.fare
      this.tryToAddPackage = false

      this.sizeSelected = destination.sizeSelected

      setTimeout(() => {
        if (!destination.isShippingPaidAtDestination && destination.isPointPoint) {
          this.$refs.CustomSelectComponentRef.selectElementFromOutside(destination.destinationAddress.districtId)
        }
        if (destination.isPointPoint && destination.isShippingPaidAtDestination) {
          this.setMarketV2(destination.destinationAddress.puntoScharffId)
        }
      }, 500)
    },
  },
  created () {
    this.$watch(() => [
      this.DestinationAddress,
      this.destinationDistrictId,
      this.destinationPuntoScharff,
      this.address,
      this.DestinationContact,
      this.securityCode,
      this.productDescription,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
      this.packageValue,
      this.shippingCost,
      this.shippingCostIsLoading,
    ], () => { this.checkValues() })
    this.$watch(() => [
      this.DestinationAddress,
      this.destinationDistrictId,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
    ], debounce(this.checkValuesToCalculate, 300))
    this.$watch(() => [
      this.DestinationAddress,
      this.destinationDistrictId,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
    ],() => { this.shippingCostIsLoading = true })
    this.$watch('destinationDistrictId', value => {
      if (value && !this.isShippingPaidAtDestination) {
        this.getScharffPoints()
      }
    })
    this.$watch('isShippingPaidAtDestination', value => {
      this.destinationDistrictId = ''
      this.destinationPuntoScharff = ''
      this.destinationDistrictData = {}
      this.selectedScharffPointData = {}
      if(value) {
        this.getScharffPointsWithDestinationPayment()
      } else {
        this.scharffPointsList = []
      }
    })

    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)) {
      this.$nextTick(() => {
        const appContainer = document.querySelector('.body_add_packagev2');
        if (appContainer) {
          appContainer.classList.add('ios-safari');
        }
      });
    }
  },
  mounted() {
    try {
      this.map = new Map();
      this.map.initMap("mp_ps_type1");
      this.initSelects();
      this.$eventBus.$on("scharffPointClearDataDestinationModal", () => {
        this.clearData();
      });

      this.$eventBus.$on("scharffPointSetDataDestinationModal", (destination) => {
        this.setData(destination);
      });
      this.getSizesForSharfPoints('P')
    } catch (e) {
      console.error("Error al montar el componente ModalScharffPointPackageV2:", e);
    }
  },
  computed: {
    hasLimaOrCallaoDistrict() {
      const originDistrict = `${this.originDistric.districtId?.text || ''}`
      const destinationDistrict = this.destinationDistrictData?.text || ''
      const originAndDestinationDistricts = `${originDistrict}${destinationDistrict}`
      return originDistrict && destinationDistrict ? originAndDestinationDistricts.toLowerCase().includes('lima') || originAndDestinationDistricts.toLowerCase().includes('callao') : true
    },
    originDistric() {
      return this.$store.getters.SCHARFFPOINT_ORDER_ORIGIN;
    },
    exceedsWeightLimit() {
      return this.packageWeight > this.maxWeight
    },
    volumetricWeight() {
      const a = this.packageWidth
      const b = this.packageHeight
      const c = this.packageDeep
      return a * b * c
    },
    exceedsVolumetricWeight() {
      if (this.sizeSelected.codigo !== 'P') return false
      return this.volumetricWeight > this.maxVolumetricWeight
    },
    volumetricWeightMsg() {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      }); 
      const maxValue = this.maxVolumetricWeight
      const currentValue = this.volumetricWeight
      return `El volumen máximo por paquete en el servicio Puntos Sharf es ${formatter.format(maxValue)} cm³. Has ingresado un volumen de ${formatter.format(currentValue)} cm³.`
    },
    DestinationContact() {
      return this.$store.getters.GENERAL_DESTINATION_CONTACT;
    },
    DestinationAddress() {
      return this.$store.getters.GENERAL_DESTINATION_ADDRESS
    },
  },
  watch:{
    securityCode(value) {
      if (value) {
        const onlyDigits = value.replace(/\D/g, '').slice(0, 4)
        this.securityCode = onlyDigits
      } else {
        this.securityCode = ''
      }
    },
    shipmentType(value){
      if(value == this.typesOfShipments.pointToHome){
        this.trackEvent('click_puntos_envia_paso_3_a_domicilio', 'dropoff')
        this.isShippingPaidAtDestination = false
      }else{
        this.trackEvent('click_puntos_envia_paso_3_a_punto', 'puntoapunto')
      }
    }
  }
};
</script>

<style>
@import '../../styles/09-componentsv2/addPackage.scss';






[data-tooltip],
.tooltip {
  position: relative;
  cursor: pointer;
}

/* Base styles for the entire tooltip */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after {
  position: absolute;
  visibility: hidden;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
  opacity: 0;
  -webkit-transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out, -webkit-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  -moz-transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out, -moz-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out, transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  pointer-events: none;
}

/* Show the entire tooltip on hover and focus */
[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after {
  visibility: visible;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
  opacity: 1;
}

/* Base styles for the tooltip's directional arrow */
.tooltip:before,
[data-tooltip]:before {
  z-index: 1001;
  border: 6px solid transparent;
  background: transparent;
  content: "";
}

/* Base styles for the tooltip's content area */
.tooltip:after,
[data-tooltip]:after {
  z-index: 1000;
  padding: 8px;
  width: 160px;
  background-color: #000;
  background-color: hsla(0, 0%, 20%, 0.9);
  color: #fff;
  content: attr(data-tooltip);
  font-size: 14px;
  line-height: 1.2;
}

/* Directions */

/* Top (default) */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after,
.tooltip-top:before,
.tooltip-top:after {
  bottom: 100%;
  left: 50%;
}

[data-tooltip]:before,
.tooltip:before,
.tooltip-top:before {
  margin-left: -6px;
  margin-bottom: -12px;
  border-top-color: #000;
  border-top-color: hsla(0, 0%, 20%, 0.9);
}

/* Horizontally align top/bottom tooltips */
[data-tooltip]:after,
.tooltip:after,
.tooltip-top:after {
  margin-left: -80px;
}

[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after,
.tooltip-top:hover:before,
.tooltip-top:hover:after,
.tooltip-top:focus:before,
.tooltip-top:focus:after {
  -webkit-transform: translateY(-12px);
  -moz-transform: translateY(-12px);
  transform: translateY(-12px);
}

/* Left */
.tooltip-left:before,
.tooltip-left:after {
  right: 100%;
  bottom: 50%;
  left: auto;
}

.tooltip-left:before {
  margin-left: 0;
  margin-right: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-left-color: #000;
  border-left-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-left:hover:before,
.tooltip-left:hover:after,
.tooltip-left:focus:before,
.tooltip-left:focus:after {
  -webkit-transform: translateX(-12px);
  -moz-transform: translateX(-12px);
  transform: translateX(-12px);
}

/* Bottom */
.tooltip-bottom:before,
.tooltip-bottom:after {
  top: 100%;
  bottom: auto;
  left: 50%;
}

.tooltip-bottom:before {
  margin-top: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-bottom-color: #000;
  border-bottom-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-bottom:hover:before,
.tooltip-bottom:hover:after,
.tooltip-bottom:focus:before,
.tooltip-bottom:focus:after {
  -webkit-transform: translateY(12px);
  -moz-transform: translateY(12px);
  transform: translateY(12px);
}

/* Right */
.tooltip-right:before,
.tooltip-right:after {
  bottom: 50%;
  left: 100%;
}

.tooltip-right:before {
  margin-bottom: 0;
  margin-left: -12px;
  border-top-color: transparent;
  border-right-color: #000;
  border-right-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-right:hover:before,
.tooltip-right:hover:after,
.tooltip-right:focus:before,
.tooltip-right:focus:after {
  -webkit-transform: translateX(12px);
  -moz-transform: translateX(12px);
  transform: translateX(12px);
}

/* Move directional arrows down a bit for left/right tooltips */
.tooltip-left:before,
.tooltip-right:before {
  top: 3px;
}

/* Vertically center tooltip content for left/right tooltips */
.tooltip-left:after,
.tooltip-right:after {
  margin-left: 0;
  margin-bottom: -16px;
}

@media screen and (max-device-width: 580px) {
  .ios-safari {
    padding-bottom:10em;
  }
}
</style>